import type { UserRole } from '@/types/domain'

export function getDefaultRouteForRole(role: UserRole): string {
  switch (role) {
    case 'admin':
      return '/admin/courses'
    case 'trainer':
      return '/trainer/meine-kurse'
    case 'member':
    default:
      return '/dashboard'
  }
}
